import React, { useEffect } from 'react';
import Navbar from '../../components/Navbars/AppNavbar.js';
import Footer from '../../components/Footers/Footer.js';
import FooterSM from '../../components/Footers/FooterSmall.js';
import BlogComponent from '../../components/Blog';
import { useSelector } from 'react-redux';
import Head from 'next/head';
import { NextSeo } from 'next-seo';

// The Storyblok Client
import Storyblok from '../../lib/storyblok';
import link from 'next/link';

export default function Blog(props) {
  const userDataRedux = useSelector((state) => state.authReducer.userData);
  const SEO = {
    title: 'MusicArt | Blog',
    description:
      'A planet-friendly NFT marketplace where music artwork reigns supreme.',
    canonical: 'https://musicart.io/blog',
  };
  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, shrink-to-fit=no"
        />
        <link rel="canonical" href="https://musicart.io/blog" />
      </Head>

      <>
        <NextSeo
          title={SEO.title}
          description={SEO.description}
          openGraph={{
            url: SEO.canonical,
            type: 'website',
            locale: 'en_IE',
            title: SEO.title,
            description: SEO.description,
            images: [
              {
                url: 'https://i.imgur.com/Q0kiEsg.jpg',
                width: 800,
                height: 600,
                alt: 'MusicArt Image',
              },
            ],
            site_name: 'MusicArt',
          }}
        />
      </>

      <Navbar transparent />
      <BlogComponent
        data={props}
        full={false}
        story={null}
        stories={props.stories}
        sidebar={props.sidebar}
      />
      <Footer />
      <FooterSM />
    </>
  );
}

export async function getStaticProps(context) {
  // console.log("tesging blogs1");
  // the slug of the story
  // let slug = "home"
  // the storyblok params
  let params = {
    version: 'draft', // or 'published' / ' draft
  };

  // checks if Next.js is in preview mode
  if (context.preview) {
    // loads the draft version
    params.version = 'draft';
    // appends the cache version to get the latest content
    params.cv = Date.now();
  }
  let testing = await Storyblok.get(`cdn/stories`, params);
  let blogs = [];
  let sidebar = {};
  testing &&
    testing.data &&
    testing.data.stories.map((story) => {
      // console.log("blog",story,testing);
      if (story.full_slug.includes('blog')) {
        if (story.full_slug.includes('sidebar')) {
          sidebar = { ...story };
          return;
        }
        blogs.push(story);
      }
    });

  // console.log("tesging blogs", testing);

  // let links = await Storyblok.get('cdn/links/', {
  //   starts_with: 'article'
  // })

  // let stories = [];
  // let test = links.data.links;

  // for (const property in test) {
  //   const { slug } = test[property];
  //   const { data } = await Storyblok.get(`cdn/stories/${slug}`, params);
  //   stories.push(data.story);
  // }

  // sorting stories
  // const sorting = (a, b) => {
  //   const aPublish = new Date(a.published_at).getTime();
  //   const bPublish = new Date(b.published_at).getTime();
  //   return aPublish < bPublish ? 1 : -1;
  // }
  // stories = stories.sort(sorting);

  // let sidebar = await Storyblok.get(`cdn/stories/sidebar`, params);

  // return the story from Storyblok and whether preview mode is active
  return {
    props: {
      stories: blogs,
      sidebar: sidebar,
      // preview: context.preview || false,
      testing: testing,
      // blogs:blogs
    },

    revalidate: 10,
  };
}
